import React from 'react';
import { FaqLoadingPlaceholder, useAnalyticsPageViewTracker, useAuthentication } from '@cp-shared-15/frontend-ui';
import { useTranslation } from 'react-i18next';
import { Faq as FaqType } from 'cpie-common';

import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { FaqUi } from './ui';
import { useFaq } from './useFaq';

const FaqWithHandlers = withLoadingAndNoConnectionHandler(FaqUi);

export const Faq: React.FC = () => {
    const { t: cms } = useTranslation('faq-cms');
    const { cmsContent } = useFaq();
    const faqObject: FaqType = {
        teaser: { ...cms('teaser', { returnObjects: true }), imageUrl: cmsContent?.teaser?.imageUrl || '' },
        content: cms('content', { returnObjects: true }),
    };
    const { isAuthenticated } = useAuthentication();
    useAnalyticsPageViewTracker('faq', true);

    return (
        <FaqWithHandlers
            isLoading={false}
            faq={faqObject}
            hasError={false}
            isLoggedIn={isAuthenticated}
            loadingPlacehloder={<FaqLoadingPlaceholder />}
        />
    );
};
